import { Modal } from '@/components/Modal';

import LogoSvg from '@/assets/breitling-simple.svg';

import * as S from './PriceModal.styles';

export interface PriceModalProps {
  children: React.ReactNode;
  isOpen: boolean;
  onClose: () => void;
}

export const PriceModal = ({ children, isOpen, onClose }: PriceModalProps) => {
  return (
    <Modal
      data-test-id='PriceModal-Modal'
      data-testid='modalPrice'
      isOpen={isOpen}
      maxWidth='md'
      onClose={onClose}
    >
      <Modal.Header data-test-id='PriceModal-ModalHeader' onClose={onClose}>
        <S.Logo
          alt='Breitling logo'
          data-test-id='PriceModal-Logo'
          height={50}
          src={LogoSvg}
          width={50}
        />
      </Modal.Header>
      <Modal.Body data-test-id='PriceModal-ModalBody'>
        <S.Body data-test-id='PriceModal-Body'>{children}</S.Body>
      </Modal.Body>
    </Modal>
  );
};

PriceModal.displayName = 'PriceModal';
